import React from "react";
import { formatPhoneNumber2 } from "../../../utils";
import { OtpTextBox } from ".";
import {Typography} from "@one-thd/sui-atomic-components";

const OtpPhoneEvoiceView = (props) => {
  const {
    otpPhoneNumber
  } = props;

  return (
    <div>
      <Typography>
        We called into your phone number 
      </Typography>
      <Typography weight='bold'>
        {formatPhoneNumber2(otpPhoneNumber)}
      </Typography>
      <OtpTextBox {...props} />
    </div>
  );
};

export default OtpPhoneEvoiceView;